<svg width="100%" height="100%" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="1.80273" y="1.5" width="15" height="15" rx="2" fill="white" />
  <rect x="1.80273" y="1.5" width="15" height="15" rx="2" stroke="white" stroke-width="2" />
  <path
    d="M13.3027 6L7.80273 11.5L5.30273 9"
    stroke="black"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
